<template>
  <div class="legend-diagnosis">
    <h3 class="legend-lable">
      {{ lang == 'CN' ? '提示及说明' : 'Tips and Instructions' }}
    </h3>
    <div class="legend-wrap">
      <legend-item
        v-for="(item, index) in diagSupport"
        :key="index"
        :icon="item.icon"
        :desc="item[lang.toLowerCase()]"
      ></legend-item>
    </div>
  </div>
</template>
<script>
export default {
  name: 'legend-diagnosis',
  props: {
    lang: {
      type: String,
      default() {
        return this.$getLang()
      }
    }
  },
  computed: {
    diagSupport() {
      return this.$store.state.diagSupport
    }
  }
}
</script>
<style lang="less">
.legend-diagnosis {
  padding-bottom: 15px;
  .legend-lable {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .legend-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .legend-item {
      width: 33%;
      .legend-icon {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>
